export const PRIMER_TIEMPO = '1';
export const SEGUNDO_TIEMPO = '2';
export const NO_JUGADO = 'N';
export const SUPLEMENTARIO = 'S';
export const PENALES = 'P';
export const CONTINUACION = 'C';
export const TRIBUNAL = 'T';
